module.exports = __webpack_public_path__ + "img/Taotao.4d37f9a7.jpeg";